// Generated by scripts/wizbuild.mjs. Edit the matching WIZ view.ts instead.
// @ts-nocheck
import { Component as AngularComponent } from '@angular/core';
import Wiz from '../../wiz';
import {AfterViewInit, OnChanges, OnDestroy, Input, ViewChild, ElementRef, signal} from '@angular/core';
import {loadMonaco} from '../../libs/monaco';
const wiz = new Wiz({ appId: 'component.code-diff', namespace: 'code-diff' });
@AngularComponent({
  selector: 'wiz-code-diff',
  templateUrl: './view.html',
  styleUrls: ['./view.scss'],
  standalone: false
})
export class ComponentCodeDiffComponent implements AfterViewInit, OnChanges, OnDestroy {
 @Input() before='';@Input() after='';@Input() label='변경 비교';
 @ViewChild('container') container!:ElementRef<HTMLElement>;
 public loading=signal(true);public error=signal('');
 private editor:any;private original:any;private modified:any;private destroyed=false;
 public async ngAfterViewInit():Promise<void>{try{
  const monaco=await loadMonaco();if(this.destroyed)return;
  this.original=monaco.editor.createModel(this.before,'yaml');this.modified=monaco.editor.createModel(this.after,'yaml');
  this.editor=monaco.editor.createDiffEditor(this.container.nativeElement,{readOnly:true,automaticLayout:true,renderSideBySide:true,useInlineViewWhenSpaceIsLimited:true,originalEditable:false,ariaLabel:this.label,minimap:{enabled:false},scrollBeyondLastLine:false,wordWrap:'on'});
  this.editor.setModel({original:this.original,modified:this.modified});
 }catch(error){this.error.set(error instanceof Error?error.message:'비교 편집기를 불러오지 못했습니다.');}finally{this.loading.set(false);}}
 public ngOnChanges():void{if(this.original)this.original.setValue(this.before);if(this.modified)this.modified.setValue(this.after);}
 public ngOnDestroy():void{this.destroyed=true;this.editor?.dispose();this.original?.dispose();this.modified?.dispose();}
}

export default ComponentCodeDiffComponent;
